<template>
  <div class="Loading">
    <i style="font-size: 1rem;" class="iconfont icon-loadding"></i><br>加载中
  </div>
</template>

<script>
var timer = null;
export default {
  props: ['con'],
  data () {
    return {
      show: false,
    }
  },
}
</script>

<style scoped>
  @keyframes xuanzhuan
	{
		from {transform: rotate(0deg);}
		to {transform: rotate(360deg);}
	}
  .Loading{
    position: fixed;
    width: 100%;
    height: 100%;
    top: calc(50% - 2rem);
    left: 0;
    z-index: 1000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue